/**
 * UI preferences store for motion-components (e.g. field tooltip visibility).
 * Host app creates an instance, registers it via setMotionUIStoreGetter, and syncs
 * από VITE_APP_SHOW_FIELD_TOOLTIP (isFieldTooltipEnabled).
 */
import { action, configure, makeObservable, observable } from 'mobx';

configure({ enforceActions: 'always' });

let currentMotionUIStore: MotionUIStore | undefined;

export class MotionUIStore {
  @observable accessor showFieldTooltip = false;

  @action setShowFieldTooltip(value: boolean): void {
    this.showFieldTooltip = value;
  }

  constructor() {
    makeObservable(this);
  }
}

/** Κρατά αναφορά στο shared UI store ώστε τα components να διαβάζουν runtime ρυθμίσεις. */
export function registerMotionUIStore(store: MotionUIStore): void {
  currentMotionUIStore = store;
}

/** Επιστρέφει το shared UI store όταν το host app το έχει ήδη καταχωρήσει. */
export function getRegisteredMotionUIStore(): MotionUIStore | undefined {
  return currentMotionUIStore;
}
